module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/35c6e0b518730b9af818f687364ab222.png";